import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

const OfflineDetector = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowNotification(true);
      // Hide reconnection notification after 3 seconds
      setTimeout(() => setShowNotification(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowNotification(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Initial check
    if (!navigator.onLine) {
      setIsOnline(false);
      setShowNotification(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showNotification && isOnline) {
    return null;
  }

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      showNotification ? 'translate-y-0' : '-translate-y-full'
    }`}>
      <div className={`px-4 py-3 text-center text-white ${
        isOnline
          ? 'bg-green-600'
          : 'bg-red-600'
      }`}>
        <div className="flex items-center justify-center space-x-2">
          {isOnline ? (
            <>
              <Wifi className="h-5 w-5" />
              <span className="font-medium">Bağlantı yeniden kuruldu</span>
            </>
          ) : (
            <>
              <WifiOff className="h-5 w-5" />
              <span className="font-medium">İnternet bağlantınız yok</span>
            </>
          )}
        </div>
        {!isOnline && (
          <p className="text-sm mt-1 opacity-90">
            Lütfen internet bağlantınızı kontrol edin
          </p>
        )}
      </div>
    </div>
  );
};

export default OfflineDetector;